<template>
    <div class="allContent">
      <!-- <van-sticky>
        <van-nav-bar title="社区" left-arrow safe-area-inset-top fixed>
          <template #left>
            <div class="left-nr" @click="$router.back()">
              <img src="../../../assets/nav/yz_nav_fh.png" alt="" />
            </div>
          </template>
        </van-nav-bar>
      </van-sticky> -->
      <div class="contentDetails">
        <div>
          发布到「<img
            src="../../../assets/game/gameCommunity_game_icon.png"
            alt=""
          />
          {{ state.gamename }}」
        </div>
      </div>
  
      <div class="typecheckBox">
        <ul>
          <li
            v-for="(item, index) in state.commentTypeList"
            :key="item.id"
            @click="changeType(item.id)"
            :class="{ active: item.id === state.currentTypeId }"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
  
      <div class="commentRegion">
        <myPublish
          :gid="state.gid"
          :commentType="state.currentTypeId"
          :username="state.username"
          :mobile="state.mobile"
          :uid="state.uid"
        >
        </myPublish>
      </div>
    </div>
  </template>
  <script setup>
  import { useRouter } from "vue-router";
  import { reactive, onMounted, onActivated } from "vue";
  import { useStore } from "vuex";
  import myPublish from "./components/myPublish.vue";
  import { getQueryString } from "@/utils/location";
  import { getCommentType } from "@/api/yzCommunity";
  const store = useStore();
  const router = useRouter();
  
  const state = reactive({
    uid: "",
    gid: "",
    username: "",
    mobile: "",
    gamename: "",
    commentTypeList: [],
    currentTypeId: "",
  });
  onActivated(() => {
    state.currentTypeId = "";
    state.gid = getQueryString("gid");
    state.gamename = getQueryString("gamename");
    state.username = getQueryString("username");
    state.mobile = getQueryString("mobile");
    state.uid = getQueryString("uid");
  
    getType();
  });
  
  // 获取帖子类型
  const getType = async () => {
    let res = await getCommentType({
      gid: state.gid,
      uid: state.uid,
    });
    if (res.data.a == "1") {
      state.commentTypeList = res.data.c;
      state.currentTypeId = state.commentTypeList[0].id;
      // console.log("获取到的评论分类", state.commentTypeList);
    } else {
      console.log("获取失败", res);
    }
  };
  
  // 更改帖子类型
  const changeType = (id) => {
    state.currentTypeId = id;
  };
  
  const publishComment = (value) => {
    console.log(value);
  };
  </script>
  <style src="../../../styles/van-sticky-nav.css" scoped></style>
  <style scoped>
  .allContent {
    padding-top: 80px;
    background-color: #f7f8fa;
    height: 100vh;
  }
  
  .contentDetails {
    font-size: 28px;
    color: #333;
    padding: 0 32px;
    display: flex;
  }
  .contentDetails img {
    width: 32px;
    height: 32px;
    vertical-align: middle;
  }
  .contentDetails span {
    color: #12cec7;
  }
  .commentRegion {
    margin-top: 24px;
    padding: 0 32px;
  
    /* 修改 */
    height: 92%;
  }
  
  
  
  .typecheckBox {
    height: 42px;
    width: 100%;
    margin: 24px 0 28px;
  }
  .typecheckBox ul {
    display: flex;
    align-items: center;
    padding-left: 32px;
    overflow-x: auto;
  }
  .typecheckBox ul li {
    height: 42px;
    border-radius: 198px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #666;
    margin-right: 16px;
    background-color: #fff;
  }
  .typecheckBox ul .active {
    color: #12cec7;
  }
  :deep(.van-hairline--bottom::after){
    border-bottom-width: 0;
  }
  </style>
  